import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import ChromeReaderModeOutlinedIcon from "@mui/icons-material/ChromeReaderModeOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import PestControlOutlinedIcon from "@mui/icons-material/PestControlOutlined";
import CodeOffOutlinedIcon from "@mui/icons-material/CodeOffOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";
import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import BrushIcon from "@mui/icons-material/Brush";
import SecurityUpdateGoodIcon from "@mui/icons-material/SecurityUpdateGood";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import InventoryIcon from "@mui/icons-material/Inventory";
import VibrationIcon from "@mui/icons-material/Vibration";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import EngineeringIcon from "@mui/icons-material/Engineering";
import StorageIcon from "@mui/icons-material/Storage";
import GroupsIcon from "@mui/icons-material/Groups";
import UploadFile from "@mui/icons-material/UploadFile";
import TagIcon from "@mui/icons-material/Tag";
import MapIcon from "@mui/icons-material/Map";
import BuildIcon from "@mui/icons-material/Build";
import TranslateIcon from "@mui/icons-material/Translate";
import { Info } from "@mui/icons-material";
import Loading from "../loading";
import Toolbar from "./toolbar";
import NavListItem from "./NavListItem";
import { UserPermissionConstants } from "../../utils/permissions";
import utils from "../../utils/utils";
import { Outlet, useNavigate } from "react-router-dom";
import "./layout.css";
// import OrganizationService from "../../api/organization";
// import AppService from "../../api/app";
// import DevicesService from "../../api/devices";
import OrganizationService from "../../api/organization";
import {
  //   GetDateTimeStringToday,
  ContainsFileExtension,
} from "../../utils/systemInfo";

import { useMediaQuery } from "@mui/material";
import MessageSender from "../message/messageSender";
import PropTypes from "prop-types";
import { OrganizationPermissionConstants } from "../../utils/organizationPermissions";
// Importing all created components
// import Sidebar from "../Sidebar/Sidebar";
// import Navbar from "../Navbar/Navbar";
// Pass the child props

const navigation = [
  { id: 0, label: "Home", icon: <HomeOutlinedIcon />, url: "/" },
  {
    id: 1,
    label: "Machines",
    icon: <LocalShippingOutlinedIcon />,
    url: "machines",
    permission: UserPermissionConstants.VIEW_MACHINES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 11,
    label: "My Machines",
    icon: <LocalShippingOutlinedIcon />,
    url: "myMachines",
    permission: UserPermissionConstants.VIEW_MY_MACHINES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 2,
    label: "Devices",
    icon: <VibrationIcon />,
    url: "devices",
    permission: UserPermissionConstants.VIEW_DEVICES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 12,
    label: "My Devices",
    icon: <VibrationIcon />,
    url: "myDevices",
    permission: UserPermissionConstants.VIEW_MY_DEVICES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 13,
    label: "Machine Groups",
    icon: <LocalShippingOutlinedIcon />,
    url: "machineGroups",
    permission: UserPermissionConstants.VIEW_MACHINES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 14,
    label: "My Machine Groups",
    icon: <LocalShippingOutlinedIcon />,
    url: "myMachineGroups",
    permission: UserPermissionConstants.VIEW_MY_MACHINES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 15,
    label: "Device Groups",
    icon: <VibrationIcon />,
    url: "deviceGroups",
    permission: UserPermissionConstants.VIEW_DEVICES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 16,
    label: "My Device Groups",
    icon: <VibrationIcon />,
    url: "myDeviceGroups",
    permission: UserPermissionConstants.VIEW_MY_DEVICES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
  },
  {
    id: 3,
    label: "Machine Status",
    icon: <Info />,
    url: "machineStatus",
    permission: UserPermissionConstants.VIEW_MACHINES,
    organizationPermission: OrganizationPermissionConstants.DEVICE_MANAGEMENT,
    dropdown: [
      {
        id: 0,
        label: "Status",
        icon: <SecurityUpdateGoodIcon />,
        url: "machineStatus",
        permission: UserPermissionConstants.VIEW_MACHINES,
        organizationPermission:
          OrganizationPermissionConstants.DEVICE_MANAGEMENT,
      },
      {
        id: 1,
        label: "Trend",
        icon: <PersonAddIcon />,
        url: "machineTrend",
        permission: UserPermissionConstants.VIEW_MACHINES,
        organizationPermission:
          OrganizationPermissionConstants.DEVICE_MANAGEMENT,
      },
      {
        id: 2,
        label: "Documentation",
        icon: <EngineeringIcon />,
        url: "machineDocumentation",
        permission: UserPermissionConstants.VIEW_MACHINES,
        organizationPermission:
          OrganizationPermissionConstants.DEVICE_MANAGEMENT,
      },
    ],
  },
  {
    id: 4,
    label: "Dashboards",
    icon: <ChromeReaderModeOutlinedIcon />,
    url: "dashboards",
    permission: UserPermissionConstants.VIEW_DASHBOARDS,
    organizationPermission: OrganizationPermissionConstants.DASHBOARDS,
  },
  {
    id: 5,
    label: "Users",
    icon: <PeopleAltOutlinedIcon />,
    url: "users",
    permission: UserPermissionConstants.VIEW_USERS,
    organizationPermission: OrganizationPermissionConstants.USER_MANAGEMENT,
  },
  {
    id: 6,
    label: "Organizations",
    icon: <LocationCityOutlinedIcon />,
    url: "organizations",
    permission: UserPermissionConstants.VIEW_ORGANIZATIONS,
    organizationPermission:
      OrganizationPermissionConstants.ORGANIZATION_MANAGEMENT,
  },
  {
    id: 7,
    label: "SiteLayout",
    icon: <MapIcon />,
    url: "/map",
    permission: UserPermissionConstants.VIEW_MAP,
    organizationPermission: OrganizationPermissionConstants.LOCATION_MANAGEMENT,
  },
  {
    id: 6,
    label: "Tags",
    icon: <TagIcon />,
    url: "tags",
    permission: UserPermissionConstants.VIEW_ORGANIZATIONS,
  },
  {
    id: 8,
    label: "Helpdesk",
    icon: <PestControlOutlinedIcon />,
    url: "indexHelpdesk",
    organizationPermission: OrganizationPermissionConstants.TICKETING,
    dropdown: [
      {
        id: 0,
        label: "Dashboard",
        icon: <ChromeReaderModeOutlinedIcon />,
        url: "indexHelpdesk",
        organizationPermission: OrganizationPermissionConstants.TICKETING,
      },
      {
        id: 1,
        label: "MyTickets",
        icon: <RateReviewOutlinedIcon />,
        url: "myTickets",
        organizationPermission: OrganizationPermissionConstants.TICKETING,
      },
      {
        id: 2,
        label: "NewTicket",
        icon: <EditOutlinedIcon />,
        url: "newTicket",
        organizationPermission: OrganizationPermissionConstants.TICKETING,
      },
      {
        id: 3,
        label: "Tickets",
        icon: <ViewKanbanOutlinedIcon />,
        url: "tickets",
        organizationPermission: OrganizationPermissionConstants.TICKETING,
      },
      {
        id: 4,
        label: "Templates",
        icon: <CropSquareOutlinedIcon />,
        url: "templates",
        organizationPermission: OrganizationPermissionConstants.TICKETING,
      },
    ],
  },
  {
    id: 9,
    label: "Admin Portal",
    icon: <AdminPanelSettingsIcon />,
    url: "/",
    dropdown: [
      {
        id: 0,
        label: "Assign Devices",
        icon: <SecurityUpdateGoodIcon />,
        url: "assignDevices",
        permission:
          UserPermissionConstants.ASSIGN_DEVICE_PROFILES_TO_ORGANIZATION,
        organizationPermission: OrganizationPermissionConstants.USER_MANAGEMENT,
      },
      {
        id: 1,
        label: "Assign Users",
        icon: <PersonAddIcon />,
        url: "assignUsers",
        permission:
          UserPermissionConstants.ASSIGN_USER_PROFILES_TO_ORGANIZATION,
        organizationPermission: OrganizationPermissionConstants.USER_MANAGEMENT,
      },
      {
        id: 2,
        label: "Assign User Devices",
        icon: <EngineeringIcon />,
        url: "devToUsers",
        permission:
          UserPermissionConstants.ASSIGN_USER_PROFILES_TO_ORGANIZATION,
        organizationPermission: OrganizationPermissionConstants.USER_MANAGEMENT,
      },
      {
        id: 3,
        label: "Signal Upload",
        icon: <UploadFile />,
        url: "signalUpload",
        permission:
          UserPermissionConstants.ASSIGN_USER_PROFILES_TO_ORGANIZATION,
      },
    ],
    permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
  },
  {
    id: 8,
    label: "DeveloperPortal",
    icon: <CodeOffOutlinedIcon />,
    url: "/",
    dropdown: [
      {
        id: 0,
        label: "HubServerConfig",
        icon: <SecurityUpdateGoodIcon />,
        url: "hubServerInfoApi",
        permission: UserPermissionConstants.VIEW_HUB_SERVER_INFO,
      },
      {
        id: 1,
        label: "UserAuditTrails",
        icon: <InventoryIcon />,
        url: "userAuditTrails",
        permission: UserPermissionConstants.VIEW_AUDIT_TRAILS,
      },
      {
        id: 2,
        label: "NamedLocationConfig",
        icon: <InventoryIcon />,
        url: "namedLocationConfig",
        permission: UserPermissionConstants.VIEW_NAMED_LOCATION_CONFIG,
      },
      {
        id: 2,
        label: "Language API",
        icon: <TranslateIcon />,
        url: "languageApi",
        permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
      },
      {
        id: 3,
        label: "OrganizationsModules",
        icon: <ViewModuleIcon />,
        url: "organizationsModules",
        permission: UserPermissionConstants.VIEW_NAMED_LOCATION_CONFIG,
      },
      {
        id: 4,
        label: "Themes Api",
        icon: <BrushIcon />,
        url: "themesApi",
        permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
      },
      {
        id: 5,
        label: "Api Keys",
        icon: <BuildIcon />,
        url: "apiKeys",
        permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
      },
    ],
    permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
  },
  {
    id: 10,
    label: "LDAP",
    icon: <StorageIcon />,
    url: "/",
    permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
    dropdown: [
      {
        id: 0,
        label: "LdapServers",
        icon: <StorageIcon />,
        url: "ldapServers",
        permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
      },
      {
        id: 1,
        label: "LdapGroups",
        icon: <GroupsIcon />,
        url: "ldapGroups",
        permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
      },
      {
        id: 2,
        label: "LdapUsers",
        icon: <PeopleAltOutlinedIcon />,
        url: "ldapUsers",
        permission: UserPermissionConstants.VIEW_DEVELOPER_PORTAL,
      },
    ],
  },
];

const openedMixin = (theme) => ({
  width: `calc(${theme.palette.custom.navWidth} + 55px)`,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: ({ prop }) => prop !== "open",
})(({ theme, open }) => ({
  width: `calc(${theme.palette.custom.navWidth} + 55px)`,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Layout(props) {
  const theme = useTheme();
  const smOnly = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(
    localStorage.getItem("sidebarOpen")
      ? localStorage.getItem("sidebarOpen") === "true"
      : !smOnly
  );
  const permissions = useSelector(({ permissions }) => permissions);
  const user = useSelector(({ user }) => user);
  const [machinesFound, setMachinesFound] = useState(true);
  const [devicesFound, setDevicesFound] = useState(true);
  const [myMachinesFound, setMyMachinesFound] = useState(true);
  const [myDevicesFound, setMyDevicesFound] = useState(true);
  const [loading, setLoading] = useState(true);
  const [backgroundImage, setBackgroundImage] = useState("");
  const [rerenderKey, setRerenderKey] = useState(0);
  const [organizationModulesIds, setOrganizationModulesIds] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && (!permissions || permissions.length === 0)) {
      navigate("/login");
    }
  }, [user, permissions, navigate]);
  function RemovePermissionsForHardcodedOrganizations(
    OrgArray,
    PermissionToRemove,
    permissionsArray
  ) {
    const organizationName = JSON.parse(
      localStorage.getItem("defaultOrganization") || "{}"
    ).full_name;
    if (!OrgArray?.includes(organizationName?.toLowerCase())) {
      return permissionsArray.filter((p) => p !== PermissionToRemove);
    }
    return permissionsArray;
  }
  function getFeatures() {
    const organization = JSON.parse(
      localStorage.getItem("defaultOrganization") || "{}"
    );
    OrganizationService.GetOperationFeatures(
      organization?.uid,
      organization?.api_key_list?.[0]?.key
    ).then((response) => {
      setLoading(false);
      setOrganizationModulesIds(
        response?.operation_profile_feature_link?.map(
          (a) => a.feature.feature_uid
        )
      );
    });
  }
  function getDevices() {
    const orgObj = JSON.parse(localStorage.getItem("defaultOrganization"));
    // DevicesService.getDevices({
    //   deviceID: "",
    //   deviceType: "",
    //   source: "",
    //   apiKey: orgObj?.api_key_list?.[0]?.key,
    //   // operationUid: organziation?.uid,
    //   historyFromDST: "",
    //   historyToDST: GetDateTimeStringToday(),
    // })
    //   .then((response) => {
    //     if (response?.device_profile?.length) {
    //       const machinesexist = Boolean(
    //         response?.device_profile.find(
    //           (m) =>
    //             m.device_type?.toLowerCase()?.includes("nerohub") ||
    //             m.device_type?.toLowerCase()?.includes("nanohub") ||
    //             m.device_type?.toLowerCase()?.includes("stratahub") ||
    //             m.device_type?.toLowerCase()?.includes("nerotrax") ||
    //             m.device_type?.toLowerCase()?.includes("train") ||
    //             m.device_type?.toLowerCase()?.includes("cyberhub") ||
    //             m.device_type?.toLowerCase()?.includes("autonomous hub")
    //         )
    //       );
    //       const devicesexist = Boolean(
    //         response?.device_profile.find(
    //           (m) => m.source.toLowerCase() === "iot"
    //         )
    //       );
    //       setMachinesFound(machinesexist);
    //       setDevicesFound(devicesexist);
    //       if (window.location.pathname.includes("devices") && !devicesexist) {
    //         navigate("/");
    //       } else if (
    //         window.location.pathname.includes("machines") &&
    //         !machinesexist
    //       ) {
    //         navigate("/");
    //       }
    //     } else {
    //       setMachinesFound(false);
    //       setDevicesFound(false);
    //     }
    //   })
    //   .catch((errorr) => {
    //     if (process.env.NODE_ENV === "development")
    //       console.log("getUserTypePermissionserrorr", errorr);
    //   });
    console.log("getDevices");
    OrganizationService.GetOperationProfileAttributes({
      uid: orgObj.uid,
      apiKey: orgObj.api_key_list?.[0]?.key,
    }).then((response) => {
      if (
        response.success &&
        response.count > 0 &&
        response?.profile_attribute?.find((a) => a.channel === "type_default")
          ?.value
      ) {
        const orgType = response?.profile_attribute?.find(
          (a) => a.channel === "type_default"
        )?.value;
        console.log("orgType", response?.profile_attribute);
        const machinesexist = orgType === "machines" || orgType === "all";
        const devicesexist = orgType === "devices" || orgType === "all";
        setMachinesFound(machinesexist);
        setDevicesFound(devicesexist);
        if (window.location.pathname.includes("devices") && !devicesexist) {
          navigate("/");
        } else if (
          window.location.pathname.includes("machines") &&
          !machinesexist
        ) {
          navigate("/");
        }
        localStorage.setItem("organizationType", JSON.stringify(orgType));
      } else {
        setMachinesFound(false);
        setDevicesFound(false);
        localStorage.setItem("organizationType", JSON.stringify("nothing"));
      }
    });
  }
  function getLinkedDevices() {
    const orgObj = JSON.parse(localStorage.getItem("defaultOrganization"));
    const person_id = user?.profileId;
    OrganizationService.GetPersonDeviceLink({
      operation_uid: orgObj?.uid,
      device_id: "",
      person_id,
      apiKey: orgObj?.api_key_list?.[0]?.key,
    })
      .then((response) => {
        if (response?.person_device_link?.length) {
          setMyMachinesFound(
            Boolean(
              response?.person_device_link.find(
                (m) =>
                  m.link &&
                  (m.device_type?.toLowerCase()?.includes("nerohub") ||
                    m.device_type?.toLowerCase()?.includes("nanohub"))
              )
            )
          );

          setMyDevicesFound(
            Boolean(
              response?.person_device_link.find(
                (m) => m.link && m.source.toLowerCase() === "iot"
              )
            )
          );
        } else {
          setMyMachinesFound(false);
          setMyDevicesFound(false);
        }
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") console.log(error);
      });
  }
  useEffect(() => {
    getDevices();
    getLinkedDevices();
    const orgObj = JSON.parse(localStorage.getItem("defaultOrganization"));
    let backgroundimageurl = null;
    for (let i in orgObj?.operation_image_list) {
      if (
        orgObj?.operation_image_list[i].image_type ===
          "web_dashboard_background" &&
        orgObj?.operation_image_list[i].status === "active"
      ) {
        if (ContainsFileExtension(orgObj?.operation_image_list[i].public_url)) {
          backgroundimageurl = orgObj?.operation_image_list[i].public_url;
          break;
        }
      }
    }
    setBackgroundImage(backgroundimageurl);
    if (permissions?.includes(UserPermissionConstants.VIEW_MAP)) {
      const OrgsWithPermissions = [
        "gses",
        "vinci",
        "nerospec sk",
        "nerospec",
        "nerospec oscon",
        "shaun roselt",
        "glencore kroondal",
        "glencore magareng",
        "glencore helena",
        "glencore thorncliff",
        "unki",
        "mine machines",
        "dwarsrivier mine",
        "strata",
        "sasol",
        "k+s minerals and agriculture gmbh",
        "glencore waterval",
        "amandelbult",
        "marula mine",
        "ghh",
        "samancor doornbosch",
        "gold fields - south deep",
        "black rock",
        "soteria risk solutions",
        "ctrack",
        "nerospec demo",
        "sibanye bathopele",
      ];
      RemovePermissionsForHardcodedOrganizations(
        OrgsWithPermissions,
        UserPermissionConstants.VIEW_MAP,
        permissions
      );
    }
    if (permissions?.includes(UserPermissionConstants.VIEW_PINGER)) {
      const OrgsWithPermissions = [
        "nerospec",
        "nerospec it",
        "nerospec networks",
        "katakomb",
        "afrihost",
        "shaun roselt",
      ];
      RemovePermissionsForHardcodedOrganizations(
        OrgsWithPermissions,
        UserPermissionConstants.VIEW_PINGER,
        permissions
      );
    }
    if (permissions?.includes(UserPermissionConstants.VIEW_GITEA_SERVERS)) {
      const OrgsWithPermissions = [
        "nerospec",
        "nerospec group",
        "nerospec sk",
        "nerospec iot",
        "nerospec oscon",
        "nerospec networks",
        "katakomb",
        "nerospec it",
        "shaun roselt",
      ];
      RemovePermissionsForHardcodedOrganizations(
        OrgsWithPermissions,
        UserPermissionConstants.VIEW_GITEA_SERVERS,
        permissions
      );
    }
    if (permissions?.includes(UserPermissionConstants.VIEW_HELPDESK)) {
      const OrgsWithPermissions = [
        "gses",
        "nerospec group",
        "nerospec sk",
        "nerospec iot",
        "katakomb",
        "nerospec networks",
        "nerospec",
        "shaun roselt",
        "nerospec it",
        "jojo",
        "glencore kroondal",
        "gold fields - south deep",
      ];
      RemovePermissionsForHardcodedOrganizations(
        OrgsWithPermissions,
        UserPermissionConstants.VIEW_HELPDESK,
        permissions
      );
    }
    getFeatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isOrgHasFeaturePermission = (item) => {
    // console.log(item.organizationPermission, organizationModulesIds, !item.organizationPermission || (organizationModulesIds?.includes(item.organizationPermission)));
    return (
      !item.organizationPermission ||
      organizationModulesIds?.includes(item.organizationPermission)
    );
  };
  const handleDrawer = () => {
    setOpen(!open);
    localStorage.setItem("sidebarOpen", !open);
    window.dispatchEvent(new Event("customEventLocalStorageChange"));
  };
  function handleRerender() {
    setRerenderKey((k) => k + 1);
  }
  function checkDeviceGroups(label) {
    switch (label) {
      case "My Machine Groups":
        return (myMachinesFound || machinesFound) && !myDevicesFound;
      case "My Device Groups":
        return myDevicesFound || !(myMachinesFound || machinesFound);
      case "Machine Groups":
        return machinesFound && !devicesFound;
      case "Device Groups":
      default:
        return devicesFound || !machinesFound;
    }
  }
  const drawer = (
    <>
      <DrawerHeader>
        <IconButton onClick={handleDrawer}>
          {theme.direction === "rtl" ? (
            <ChevronRightIcon />
          ) : (
            <ChevronLeftIcon />
          )}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {permissions && !loading ? (
          navigation.map((item, index) =>
            isOrgHasFeaturePermission(item) &&
            utils.hasPermission(item.permission, permissions) &&
            (item.label !== "Devices" || devicesFound) &&
            (item.label !== "Machines" || machinesFound) &&
            (item.label !== "My Devices" || myDevicesFound) &&
            (item.label !== "My Machines" || myMachinesFound) &&
            (![
              "Machine Groups",
              "My Machine Groups",
              "Device Groups",
              "My Device Groups",
            ]?.includes(item.label) ||
              checkDeviceGroups(item.label)) ? (
              <NavListItem
                key={index}
                menuOpen={open}
                navItem={item}
                onRerender={handleRerender}
              />
            ) : null
          )
        ) : (
          <Box sx={{ height: "30vh", pt: "10%" }}>
            <Loading />
          </Box>
        )}
      </List>
    </>
  );
  const container =
    props.window !== undefined ? () => props.window().document.body : undefined;
  useEffect(() => {
    document.getElementsByTagName("body")[0].style = { overflow: "auto" };
    document.getElementById("AppBar").style = { padding: 0 };
  });
  return (
    <Box sx={{ display: "flex", minHeight: "100%" }}>
      {/* Attaching all file components */}
      <Toolbar handleDrawerstate={handleDrawer} />
      <Box
        component="nav"
        sx={{
          width: {
            xs: open ? `calc(${theme.palette.custom.navWidth} + 55px)` : 0,
            sm: open
              ? `calc(${theme.palette.custom.navWidth} + 55px)`
              : `calc(${theme.spacing(7)} + 1px)`,
          },
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <MuiDrawer
          container={container}
          variant="temporary"
          open={open}
          anchor={"left"}
          onClose={handleDrawer}
          onOpen={handleDrawer}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: `calc(${theme.palette.custom.navWidth} + 55px)`,
              color: theme.palette.custom.text,
            },
          }}
        >
          {drawer}
        </MuiDrawer>
        <Drawer
          PaperProps={{
            sx: {
              color: theme.palette.custom.text,
              display: { xs: "none", sm: "block" },
            },
          }}
          variant="permanent"
          open={open}
          onOpen={handleDrawer}
          onClose={handleDrawer}
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        key={rerenderKey}
        component="main"
        sx={{
          flexGrow: 1,
          p: "8px 8px 4px 8px",
          backgroundColor: theme.palette.custom.backgroundColor,
          minHeight: `calc(100vh - 64px)`,
          position: "relative",
          top: "64px",
          width: "100%",
          overflow: "auto",
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          // paddingBottom: "10px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            padding: "0px",
            margin: "0px",
            backgroundColor: theme.palette.custom.backgroundColor,
            borderRadius: "16px",
            border: `1px solid ${theme.palette.custom.borderColor}`,
          }}
        >
          <Outlet context={{ open }} />
        </Box>
      </Box>
      <MessageSender />
    </Box>
  );
}
Layout.propTypes = {
  window: PropTypes.func,
};
